import React, {useState} from 'react';
import axios from "axios";
import {Button, Card, CardBody, CardHeader, Option, Select, Textarea, Typography} from "@material-tailwind/react";
import InputMask from "react-input-mask";

const NewDiscount = () => {
    const [error, setError] = useState(null)

    const handleSubmit = async () => {

    }

    return (
        <>
            <div className="mt-12">
                <div className="mb-4 grid grid-cols-1 gap-6 xl:grid-cols-1">
                    <Card className="overflow-hidden xl:col-span-2 border border-blue-gray-100 shadow-sm">
                        <CardHeader
                            floated={false}
                            shadow={false}
                            color="transparent"
                            className="m-0 flex items-center justify-between p-6"
                        >
                            <div>
                                <Typography variant="h6" color="blue-gray" className="mb-1">
                                    Alta descuento
                                </Typography>
                            </div>
                        </CardHeader>
                        <CardBody className="px-0 pt-0 pb-2 mx-6">
                            <div className="mt-0 mb-2 w-full">
                                <div className="mb-1 flex flex-col gap-6">
                                    <Typography variant="h6" color="blue-gray" className="-mb-3">
                                        Clave catastral
                                    </Typography>
                                    <input
                                        type="text"
                                        placeholder="51XXXX-XXX-XXX"
                                        className="p-2 w-full border border-gray-300 rounded"
                                    />
                                    <Typography variant="h6" color="blue-gray" className="mb-0">
                                        Descuento
                                    </Typography>
                                    <Typography variant="h6" color="blue-gray" className="mb-0">
                                        Notas
                                    </Typography>
                                    <Textarea size="lg"
                                              rows={6}
                                              className={`mt-2 !border-blue-gray-200 focus:!border-0 focus:ring focus:ring-blue-500 focus:ring-inset`}
                                              labelProps={{
                                                  className: "!border-0 before:!border-0 after:!border-0",
                                              }}
                                    />
                                </div>
                                {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
                                <Button className="mt-6" fullWidth onClick={handleSubmit}>
                                    Enviar
                                </Button>
                            </div>
                        </CardBody>
                    </Card>
                </div>
            </div>
        </>
    );
};

export default NewDiscount;
